"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.expanderDefaultProps = exports.expanderContentDefaultProps = exports.FOCUS_OUTLINE_WIDTH = exports.FOCUS_OUTLINE_OFFSET = exports.EXPANDER_HEADER_COLOR = void 0;
var _utils = require("@amzn/stencil-design-tokens/js/web/utils");
var _interfaces = require("./interfaces");
const expanderContentDefaultProps = exports.expanderContentDefaultProps = {
  topSpacing: 0,
  isExpanded: false,
  shouldAnimateImmediately: false,
  shouldAnimate: true
};
const expanderDefaultProps = exports.expanderDefaultProps = {
  shouldExpandOnMount: false,
  shouldAnimate: true,
  contentSpacing: 'S300',
  size: _interfaces.ExpanderSize.Default,
  layout: _interfaces.ExpanderLayout.Default
};
const EXPANDER_HEADER_COLOR = exports.EXPANDER_HEADER_COLOR = (0, _utils.token)('color.text.primary');
const FOCUS_OUTLINE_WIDTH = exports.FOCUS_OUTLINE_WIDTH = 2;
const FOCUS_OUTLINE_OFFSET = exports.FOCUS_OUTLINE_OFFSET = 1;